import { Sparkle, Heart, StarBurst, Squiggle } from "./Decorations";
import AboutCarousel from "./AboutGallery";

const BADGES = [
  "Rheumatologist",
  "Autoimmune Disease Expert",
  "Women's Health Advocate",
  "Minority Health Advocate",
  "Marathon Runner",
  "Educator",
  "Mentor",
  "Fitness Enthusiast",
  "Music Lover",
  "Former Competitive Figure Skater",
  "Pianist",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 bg-white overflow-hidden"
    >
      <Sparkle className="absolute top-20 right-12" color="#8E44AD" size={22} />
      <Heart className="absolute bottom-32 left-10" color="#C7A5D9" size={24} />
      <StarBurst className="absolute -top-8 left-1/3 opacity-30 hidden lg:block" size={60} />

      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 reveal-left relative">
          <AboutCarousel />
          <div className="absolute -z-10 inset-0 bg-gradient-to-tr from-lavender-bg via-white to-pale-blue/40 rounded-[2rem] blur-2xl opacity-70" />
          {/* Floating accent card */}
          <div className="hidden md:flex absolute -bottom-6 -right-4 bg-white rounded-2xl px-5 py-4 border border-lavender/60 shadow-xl items-center gap-3 reveal-scale z-10">
            <Heart color="#6F2DA8" size={22} />
            <div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-violet">Practicing</div>
              <div className="font-display text-[13px] tracking-[0.18em] uppercase text-plum">
                Rheumatology
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="pill mb-5 reveal" data-testid="about-pill">
            Meet
          </p>
          <h2
            className="h-display text-3xl sm:text-4xl leading-tight title-underline reveal"
            data-testid="about-title"
          >
            About Dr. Maggie Cadet
          </h2>
          <div className="mt-3 max-w-[200px]">
            <Squiggle className="w-full h-4 opacity-70" color="#8E44AD" />
          </div>

          <p className="mt-8 text-[17px] leading-relaxed text-charcoal/85 reveal-blur">
            Dr. Maggie Cadet is a clinical board-certified rheumatologist with a passion for arthritis
            education, autoimmune disease awareness, women's health, minority health, fitness,
            movement, and helping patients live healthier lives. She brings together medical
            expertise, patient education, community outreach, and wellness-focused storytelling to
            make rheumatology easier to understand.
          </p>

          <ul
            data-testid="about-badges"
            className="mt-9 flex flex-wrap gap-2.5"
            aria-label="Areas of expertise and interests"
          >
            {BADGES.map((b, i) => (
              <li
                key={b}
                className="reveal-scale"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <span className="inline-block px-3.5 py-1.5 rounded-full text-[12px] tracking-[0.1em] uppercase font-medium text-plum bg-lavender-bg border border-lavender/60 hover:bg-royal hover:text-white hover:border-royal hover:-translate-y-0.5 transition-all duration-300 cursor-default">
                  {b}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
